
export class Video {
    initYoutubeVideo() {
        document.querySelectorAll('.js-video-container').forEach(container => {
            const videoUrl = container.dataset.video;
            const overlay = container.querySelector('.js-video-overlay');
            const thumbnail = container.querySelector('.js-video-thumbnail');
            const iframe = container.querySelector('.js-video-frame');

            const videoId = this.extractVideoId(videoUrl);
            const embedUrl = this.getEmbedUrl(videoUrl, videoId);
            const thumbnailUrl = this.getThumbnailUrl(videoUrl, videoId);

            if (!thumbnail.src || thumbnail.src === window.location.href) {
                thumbnail.src = thumbnailUrl;
            }

            overlay.addEventListener('click', () => {
                iframe.src = `${embedUrl}?autoplay=1`;
                overlay.classList.add('hidden');
                thumbnail.classList.add('hidden');
            });
        });
    }

    extractVideoId(url) {
        if (url.includes('youtube.com')) {
            return url.split('v=')[1]?.split('&')[0];
        }

        return null;
    }

    getEmbedUrl(url, id) {
        if (url.includes('youtube')) {
            return `https://www.youtube.com/embed/${id}`;
        }

        return '';
    }

    getThumbnailUrl(url, id) {
        if (url.includes('youtube')) {
            return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
        }
    }
}
